import { useState } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';
import Modal from '@mui/material/Modal';

import { ButtonBase } from '../../../../shared/Button';

import PrizeForm from './PrizeForm.jsx';
import WinnersTable from './WinnersTable/WinnersTable.jsx';
import FormActions from './FormActions.jsx';
import usePrizeForm from './usePrizeForm';

export const PickWinnersModal = ({
  prize,
  modalOpen,
  closeModal,
  sortingStatus,
  changeSort,
}) => {
  const { t } = useTranslation('campaigns');
  const [winnersNumber, setWinnersNumber] = useState(1);
  const [winnerPicked, setWinnerPicked] = useState(false);
  const { values, ...form } = usePrizeForm({
    prizeValues: prize,
  });

  return (
    <ModalContainer open={modalOpen} onClose={closeModal}>
      <Wrapper>
        <Nav>
          <NavLeft>
            <Header variant="header">{t('prizes.shortName')}</Header>
          </NavLeft>
          <NavRight>
            <Cancel onClick={closeModal} mode="outline" variant="black">
              {t('prizes.close')}
            </Cancel>
          </NavRight>
        </Nav>
        <Container>
          <Box>
            <FormSection>
              <FormContainer>
                <PrizeForm isShow={true} values={values} {...form} />
                <FormActions
                  prize={prize}
                  winnersNumber={winnersNumber}
                  setWinnersNumber={setWinnersNumber}
                  setWinnerPicked={setWinnerPicked}
                />
              </FormContainer>
            </FormSection>
            <WinnersTable
              prize={prize}
              sortingStatus={sortingStatus}
              changeSort={changeSort}
              winnerPicked={winnerPicked}
            />
          </Box>
        </Container>
      </Wrapper>
    </ModalContainer>
  );
};

const ModalContainer = styled(Modal)`
  overflow: scroll;
`;

const Wrapper = styled.div`
  background-color: ${themeGet('colors.white')};
  border-radius: 8px;
  max-width: 1500px;
  margin: 50px auto;
`;

const Box = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media (max-width: 900px) {
    display: block;
  }
`;

const FormSection = styled.div`
  width: 45%;
  @media (max-width: 900px) {
    width: 100%;
  }
`;

const FormContainer = styled.div`
  background-color: ${themeGet('colors.white')};
  min-height: 484px;
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
  padding: 15px 24px 7px 24px;
`;

const Container = styled.div`
  background-color: ${themeGet('colors.background')};
  padding: 19px 20px;
  border-radius: 8px;
  height: 100%;
`;

const Header = styled.div`
  line-height: 24px;
  cursor: pointer;
  color: ${themeGet('colors.black.80')};
  font-size: 18px;
  font-weight: 500;
  font-family: 'Montserrat', sans-serif;
  padding: 12px 10px 15px;
  margin: 0 9px 0 0;

  &:last-child {
    margin: 0;
  }
`;

const NavLeft = styled.div`
  display: flex;
`;
const NavRight = styled(NavLeft)``;

const Cancel = styled(ButtonBase)`
  margin-right: 15px;
  padding: 12px 29.3px;
  font-size: 16px;
  font-weight: 500;
`;

const Nav = styled.nav`
  display: flex;
  height: 90px;
  justify-content: space-between;
  padding: 21px 20px 19px 20px;
  border-bottom: 1px solid ${themeGet('colors.black.10')};
`;
